import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import formatUtcToLocalDate from 'utils/formatUtcToLocalDate';

import timeDateFormat from 'config/timeDateFormat';

import EventLogViewTableRow from './EventLogViewTableRow';

const styles = theme => ({
  root: {
    padding: '0 0 24px 0',
    minHeight: 300,
    overflow: 'hidden',
  },
  tableRow: {
    height: 35,
  },
  tableCell: {
    paddingTop: 5,
    paddingBottom: 5,
    borderTop: `1px solid ${theme.palette.primary.A100}`,
  },
  tableCellDate: {
    width: 120,
  },
  tableCellActions: {
    width: 16,
    paddingRight: 29,
    '&:last-child': {
      paddingRight: 29,
    },
  },
  tableCellEmpty: {
    textAlign: 'center',
  },
});

const EventLogViewTableBody = ({
  eventLog,
  date,
  business,
  classes,
}) => (
  <div className={classes.root}>
    <Table className={classes.table}>
      <TableBody>
        {eventLog.length === 0 && (
          <TableRow className={classes.tableRow}>
            <TableCell className={classNames(classes.tableCell, classes.tableCellEmpty)} colSpan={3}>
              No events found
            </TableCell>
          </TableRow>
        )}
        {eventLog.map(item => (
          <EventLogViewTableRow
            key={item.ID}
            {...item}
            business={business}
          />
        ))}
      </TableBody>
    </Table>
  </div>
);

EventLogViewTableBody.propTypes = {
  eventLog: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    tableRow: PropTypes.string.isRequired,
    tableCell: PropTypes.string.isRequired,
    tableCellDate: PropTypes.string.isRequired,
    tableCellActions: PropTypes.string.isRequired,
  }).isRequired,
};

EventLogViewTableBody.defaultProps = {
  business: {},
};

export default withStyles(styles)(EventLogViewTableBody);



// WEBPACK FOOTER //
// ./src/components/patient/EventLogViewDialog/EventLogViewTableBody.js